export const LOCAL_STORAGE_KEYS = {
  TOKEN: 'token',
  FIREBASE: 'firebase_token',
}
